var map = {
	"./山羊奶.jpg": 94539,
	"./水牛奶.jpg": 47322,
	"./烏骨雞蛋.jpg": 93735,
	"./牛奶.jpg": 35580,
	"./雞蛋.jpg": 66158,
	"./頂級山羊奶.jpg": 24786,
	"./頂級水牛奶.jpg": 26043,
	"./頂級烏骨雞蛋.jpg": 14875,
	"./頂級牛奶.jpg": 87801,
	"./頂級雞蛋.jpg": 2877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96485;